function normalizeCustomListEntry(entry) {
  const raw = entry && typeof entry === "object" ? entry : {};
  const listId = raw.listId == null ? "" : String(raw.listId);
  const listName = raw.listName == null ? "" : String(raw.listName);
  const archived = raw.archived === true;
  const archivedAt =
    archived && raw.archivedAt != null && String(raw.archivedAt)
      ? String(raw.archivedAt)
      : null;
  return { listId, listName, archived, archivedAt };
}

function normalizeCustomListIds(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeCustomListEntry).filter((e) => e.listId);
}

function activeCustomLists(list) {
  return normalizeCustomListIds(list).filter((e) => !e.archived);
}

function archivedCustomLists(list) {
  return normalizeCustomListIds(list)
    .filter((e) => e.archived)
    .slice()
    .sort((a, b) => {
      const at = a.archivedAt || "";
      const bt = b.archivedAt || "";
      if (at !== bt) return at < bt ? -1 : 1;
      return a.listId < b.listId ? -1 : a.listId > b.listId ? 1 : 0;
    });
}

function withArchived(entry, archivedAt) {
  const e = normalizeCustomListEntry(entry);
  return {
    ...e,
    archived: true,
    archivedAt:
      archivedAt != null && String(archivedAt)
        ? String(archivedAt)
        : e.archivedAt || "",
  };
}

function withRestored(entry) {
  const e = normalizeCustomListEntry(entry);
  return { ...e, archived: false, archivedAt: null };
}

function partitionListsForReorder(all, activeOrderedIds) {
  const normalized = normalizeCustomListIds(all);
  const byId = new Map(normalized.map((e) => [e.listId, e]));
  const active = [];
  const seen = new Set();
  for (const id of activeOrderedIds || []) {
    const e = byId.get(String(id));
    if (!e || e.archived || seen.has(e.listId)) continue;
    active.push(e);
    seen.add(e.listId);
  }
  for (const e of normalized) {
    if (!e.archived && !seen.has(e.listId)) {
      active.push(e);
      seen.add(e.listId);
    }
  }
  const archived = normalized.filter((e) => e.archived);
  return active.concat(archived);
}

module.exports = {
  normalizeCustomListEntry,
  normalizeCustomListIds,
  activeCustomLists,
  archivedCustomLists,
  withArchived,
  withRestored,
  partitionListsForReorder,
};
